import axios from "axios";
import { Car } from "../components/Types/Car";
import { apiBaseUrl } from "../constants/config";

export interface PaginatedCarsResponse {
  data: Car[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export const getPublicCarsInStockPaginated = async (
  page: number,
  limit: number,
): Promise<PaginatedCarsResponse> => {
  const response = await axios.get<PaginatedCarsResponse>(
    `${apiBaseUrl}/car-stock/paginated`,
    { params: { page, limit } },
  );
  return response.data;
};
